import { stringify } from "query-string";
import { SERVER } from "../constants";
import { MAP_URL } from "../constants/urls";
import { HttpClient } from "../utils/requests";
import { toEnglishDigits } from '../utils/utils';
import { adminUserMapperListResponse } from "../panels/adminUsers/adminUsersMapper";
import { insertPaybillMapperListResponse } from "../panels/hr/insertPaybill/insertPaybillMapper";
import { paybillsMapperListResponse } from "../panels/hr/paybills/paybillsMapper";
import { requestsMapperListResponse } from "../panels/hr/requests/requestsMapper";





export function getList(resource, params) {
  params = toEnglishDigits(params)
  const { page, perPage } = params.pagination;
  let { field, order } = params.sort;
  let sortKey = field;
  if (['user', 'customerCategory',
    'customerPriority', 'customerRating',
    'contactCategory', 'adminUsers',
    'preferCall', 'orderType',
    'storage',
    'clue', 'reminder',
    'sendSMS',
    'notifications',
    'transaction',
    'productCapacity',
    'insertPaybill',
    'package', 'statusCall', 'codes', 'whatsapp', 'product', 'customer', 'contact', 'loadingRequest', 'branch', 'status', 'statusLoading', 'report', 'reportstat', 'need', 'unit', 'unitProcessor', 'needCategory', 'productCategory'].includes(resource) && sortKey === 'id') {

    sortKey = 'updatedAt';
  }
  if (['baseUnit', 'productUnit', 'rawMaterial'].includes(resource) && sortKey === 'id') {
    sortKey = 'order';
    order = "ASC";

  }
  const query = {
    range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    sort: JSON.stringify([sortKey, order]),
    from: JSON.stringify((page - 1) * perPage),
    to: JSON.stringify(page * perPage - 1),
    filter: JSON.stringify(params.filter),
    phoneNumber: params.filter.phoneNumber
  };
  const url = `${SERVER}/${MAP_URL[resource]}?${stringify(query)}`;

  return HttpClient(url).then(({ headers, json }) => {
    if (resource === 'adminUsers') {
      return adminUserMapperListResponse(json, headers);
    } else if (resource === 'insertPaybill') {
      return insertPaybillMapperListResponse(json, headers);

    } else if (resource === 'paybills') {
      return paybillsMapperListResponse(json, headers);
    } else if (resource === 'request') {
      return requestsMapperListResponse(json, headers);
    }

    return {
      data: json.map((resource) => ({
        ...resource,
        id: resource.phoneNumber,
      })),
      total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
  });
}
